export enum RolesTypes {
  fullControl = 'fullControl',
  locationManager = 'locationManager',
  reviewManager = 'reviewManager',
  reviewContributor = 'reviewContributor',
  socialManager = 'socialManager',
  socialContributor = 'socialContributor',
}

export const ROLES_IDS: Record<RolesTypes, string> = {
  [RolesTypes.fullControl]: 'a58564cf-d2a5-40aa-8ba4-6f8bb4683869',
  [RolesTypes.locationManager]: '16b491c8-029a-454b-aec2-e6bd5eb3654f',
  [RolesTypes.reviewManager]: '385c1e81-ac37-4d23-8996-352253510344',
  [RolesTypes.reviewContributor]: 'bb40b82e-4742-45c9-bdbf-96fc90c92d69',
  [RolesTypes.socialManager]: 'a132ad1b-1e77-47c5-a0fc-9cf4849371b9',
  [RolesTypes.socialContributor]: '2b9eeb44-c40d-4c86-93a4-805bc34ff86d',
} as const

export const ROLES_NAMES = {
  [ROLES_IDS[RolesTypes.fullControl]]: RolesTypes.fullControl,
  [ROLES_IDS[RolesTypes.locationManager]]: RolesTypes.locationManager,
  [ROLES_IDS[RolesTypes.reviewManager]]: RolesTypes.reviewManager,
  [ROLES_IDS[RolesTypes.reviewContributor]]: RolesTypes.reviewContributor,
  [ROLES_IDS[RolesTypes.socialManager]]: RolesTypes.socialManager,
  [ROLES_IDS[RolesTypes.socialContributor]]: RolesTypes.socialContributor,
} as const

export type RolesIdsType = (typeof ROLES_IDS)[RolesTypes]

export interface RoleProps {
  id: RolesIdsType
  name: string
}
